import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';
import {DEBTOR} from '../../constants/MicroServiceConstants';

const initialData = {
  notePadTableData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'notePadTable',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getData: (state, action) => {
      state.notePadTableData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {getData, fetchStart, fetchError, resetMsg} = slice.actions;

export const fetchData = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${DEBTOR}/find/all/special/notes/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
